import axiosClient from "@/utils/axios-client";
import {
  AddBrandRequestBody,
  AddMarkupInfoRequestBody,
  AddProductRequestBody,
} from "@/shared/api/buyer-requests/types";
import { buyerRequestsUrl } from "@/shared/api/buyer-requests/url";

// 호출부가 res.status로 성공을 판단하므로 AxiosResponse를 그대로 돌려준다.
export const buyerRequestsMutationApi = {
  // 취급하지 않는 브랜드 추가 요청
  addBrand: async (buyerId: number, params: AddBrandRequestBody) =>
    await axiosClient.post(buyerRequestsUrl.addBrand(buyerId), params),

  // 브랜드 마크업 정보 추가 요청
  addMarkupInfo: async (buyerId: number, params: AddMarkupInfoRequestBody) =>
    await axiosClient.post(buyerRequestsUrl.addMarkupInfo(buyerId), params),

  // 취급하지 않는 상품(SKU) 추가 요청
  addProduct: async (buyerId: number, params: AddProductRequestBody) =>
    await axiosClient.post(buyerRequestsUrl.addProduct(buyerId), params),
};
